import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";
import { RETENTION_API } from "api/url_helper";
import { RetentionFormValues } from "modules/Pharmacy/Retention/helpers/retention.types";

const api = new APIClient();

export const retentionApiService = {

  // SELECT ALL
  getSelectAllData: (params: any) => {
    return api.create(RETENTION_API.RETENTION_API + "SelectAll", params);
  },

  // SELECT BY ID
  getSelectData: (id: number | string) => {
    return api.create(RETENTION_API.RETENTION_API + "Select", { retentionid: id });
  },

  verifyPin: (payload: { verifypin: string, retentionid: number, studyid: number, verifiedby: number }) => {
    return api.create(RETENTION_API.RETENTION_API + "Verify", payload);
  },

  // INSERT
  insertData: (payload_data: RetentionFormValues) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user.userid,

    };

    return api.create(RETENTION_API.RETENTION_API + "Insert", payload);
  },

  // UPDATE
  updateData: (payload_data: RetentionFormValues & { updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user.userid,

    };
    return api.create(RETENTION_API.RETENTION_API + "Update", payload);
  },

  // DELETE
  deleteData: (payload_data: { retentionid: number | null; updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      retentionid: payload_data.retentionid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(RETENTION_API.RETENTION_API + "Delete", payload);
  },
};
